export const TRACKING_EVENTS = {
  // Session
  APP_OPENED: 'App Opened',
  USER_LOGGED_IN: 'User Logged In',
  USER_LOGGED_OUT: 'User Logged Out',
  SESSION_EXPIRED: 'Session Expired',

  // Onboarding
  WELCOME_TOUR: 'Welcome Tour',

  // Machines tabs
  MACHINE_LIVE: 'Machine Live',
  MACHINE_PERFORMANCE: 'Machine Performance',
  MACHINE_HISTORY: 'Machine History',
  MACHINE_TIMELINE: 'Machine Timeline',
  MACHINE_SCHEDULED: 'Machine Scheduled',

  // Machine management
  MACHINE_CONFIGURATION: 'Machine Configuration',

  // Info Bar
  INFO_BAR: 'Info Bar',

  // Times
  TIMES: 'Times',

  // Modules
  WALLBOARD: 'Wallboard',
  OPERATOR_PANEL: 'Operator Panel',
  PLANBOARD: 'Planboard',
  SEARCH: 'Search',

  // Documents
  DOCUMENT: 'Document',

  // Settings
  SETTINGS: 'Settings',
  USER_MANAGEMENT: 'User Management',
  CONNECTOR: 'Connector',
  DEVICE_MANAGEMENT: 'Device Management',

  // Item Linking
  ITEM_LINKING: 'Item Linking',

  // Item screens
  PART: 'Part',
  RECIPE: 'Recipe',
  RECIPE_STEP: 'Recipe Step',
  BATCH: 'Batch',
  JOB: 'Job',
  PRODUCTION_ORDER: 'Production Order',
  NC_FILE: 'NC File',
  TOOL: 'Tool',
} as const;

export type TrackingEventName = (typeof TRACKING_EVENTS)[keyof typeof TRACKING_EVENTS];
